import {Component, ElementRef} from '@angular/core';
import {Http} from '@angular/http';
import {ActivatedRoute} from '@angular/router';
import {UsersService} from "../../../models/users/users.service";
import {ToasterService} from 'angular2-toaster/angular2-toaster';

@Component({
    selector: 'role-editor',
    templateUrl: 'role-editor.template.html',
    styleUrls: ['role-editor.css']
})
export class RoleEditorComponent {

    public loadedRolesForShow: any;
    public allItems: any;

    public open_state: any = {};

    public notassignedRoles = {};

    constructor(
        public usersService: UsersService,
        private toasterService: ToasterService
    ) {
        this._loadRoles();
    }

    private _loadRoles() {
        this.usersService.getPermissionsByRole().subscribe(
            (res) => {
                this._setLoadedRoles(res);
            }
        );
    }

    private _setLoadedRoles(res: any) {
        this.loadedRolesForShow = res.data['by_roles'];
        this.allItems = res.data['items'];
        this.notassignedRoles = this._getAllRoles(res.data);
    }

    roleToggle(id: any, x1: any) {
        /*
        let blocks: any = x1.getElementsByClassName('inblock');
        if (! blocks || blocks.length < 0.1) return;
        if (this.open_state[id]) {
            this.open_state[id] = undefined;
            blocks[0].parentNode.style.height = '';
        } else {
            this.open_state[id] = true;
            blocks[0].parentNode.style.height = blocks[0].offsetHeight + 'px';
        }
        */

        if (this.open_state[id]) {
            this.open_state[id] = undefined;
        } else {
            this.open_state[id] = true;
        }
    }

    private _getAllRoles(rolesByUser) {
        let _rolesO = {};
        let _rolesN = {};
        let result = {};
        for (let role of rolesByUser['by_roles']) {
            result[role.id] = [];
            //_rolesO[role.id] = {'item_id': role.id, 'name': role.name, 'type': 1, 'description': ''};
            _rolesN[role.id] = {'item_id': role.id, 'name': role.name, 'type': 1, 'description': '', 'items': {}};
            for (let sub_role of role.items) {
                //_rolesO[sub_role.item_id] = {'item_id': sub_role.item_id, 'name': sub_role.name, 'type': sub_role.type, 'description': sub_role.description};
                _rolesN[role.id]['items'][sub_role.item_id] =
                    {'item_id': sub_role.item_id, 'name': sub_role.name, 'type': sub_role.type, 'description': sub_role.description};
            }
        }

        for (let role of rolesByUser['items']) {
            _rolesO[role['id']] = role;
        }

        let checkForRecursion = (id, hid) => {
            let check = (id) => {
                if (id == hid) return true;
                if (_rolesN[id]) {
                    for (let id0 in _rolesN[id].items) {
                        if (! _rolesN[id].items.hasOwnProperty(id0)) continue;
                        if (check(id0)) return true;
                    }
                }
                return false;
            };
            return check(id);
        };

        let checkForSame = (id, hid) => {
            let check = (hid) => {
                if (! _rolesN[hid]) return false;
                if (_rolesN[hid].items[id]) return true;
                for (let id0 in _rolesN[hid].items) {
                    if (! _rolesN[hid].items.hasOwnProperty(id0)) continue;
                    if (check(id0)) return true;
                }
            };
            return check(hid);
        }

        for (let hid in result) {
            if (! result.hasOwnProperty(hid)) continue;

            for (let id in _rolesO) {
                if (! _rolesO.hasOwnProperty(id)) continue;
                //if (id == hid) continue;
                if (checkForSame(id, hid)) continue;
                if (checkForRecursion(id, hid)) continue;

                result[hid][id] = _rolesO[id];
            }
        }

        let result2 = {};
        for (let i in result) {
            if (! result.hasOwnProperty(i)) continue;
            let resRole = [];
            for (let j in result[i]) {
                if (! result[i].hasOwnProperty(j)) continue;
                resRole.push(result[i][j]);
            }
            result2[i] = resRole;
        }

        return result2;
    }

    addPermissionForRole(id, hid) {
        if (this._new_role_in_process) return;
        this._new_role_in_process = true;
        this.usersService.addPermissionForRole(id, hid).subscribe(
            (res) => {
                this._new_role_in_process = false;
                this._setLoadedRoles(res);
                this.toasterService.pop('success', 'Success', 'Permission Added');
            },
            (error) => {
                this._new_role_in_process = false;
                this.toasterService.pop('error', 'Error', 'Error adding a permission. Try again');
            }
        );
    }

    deletePermissionForRole(id, hid) {
        if (this._new_role_in_process) return;
        this._new_role_in_process = true;
        this.usersService.deletePermissionForRole(id, hid).subscribe(
            (res) => {
                this._new_role_in_process = false;
                this._setLoadedRoles(res);
                this.toasterService.pop('success', 'Success', 'Permission Deleted');
            },
            (error) => {
                this._new_role_in_process = false;
                this.toasterService.pop('error', 'Error', 'Error deleting a permission. Try again');
            }
        );
    }

    showEditRoleName(role: any) {
        if (this._new_role_in_process) return;
        role._in_edit = true;
        role._in_error = false;
        role._edit_name = role.name;
    }

    hideEditRoleName(role: any) {
        if (this._new_role_in_process) return;
        role._in_edit = false;
    }

    renameRole(id: any, name: any, role: any)
    {
        if (this._new_role_in_process) return;
        this._new_role_in_process = true;
        role._in_error = false;
        this.usersService.renameRole(id, name).subscribe(
            (res) => {
                this._setLoadedRoles(res);
                this.toasterService.pop('success', 'Success', 'Role Renamed');
                this._new_role_in_process = false;
                //role._in_edit = false;
            },
            (error) => {
                try {
                    this.toasterService.pop('error', 'Error', 'Error renaming role');
                    this._new_role_in_process = false;
                    role._in_error = true;
                    role._txt_error = false;

                    for (let err of error.json().errors) {
                        if (err.field == 'name') {
                            role._txt_error = err.message;
                            break;
                        }
                    }
                } catch (e) {}
            }
        );
    }

    removeRole(role: any) {
        if (this._new_role_in_process) return;
        this._new_role_in_process = true;
        this.usersService.deleteRole(role.id).subscribe(
            (res) => {
                this._new_role_in_process = false;
                this._setLoadedRoles(res);
                this.toasterService.pop('success', 'Success', 'Role Deleted');
            },
            (error) => {
                this.toasterService.pop('error', 'Error', 'Error deleting role');
                this._new_role_in_process = false;
            }
        );
    }

    isAddNewRole: any = false;
    new_role_name: any;
    _new_role_in_process: any = false;
    _new_role_in_error: any = false;
    _new_role_txt_error: any = false;

    showAddNewRole() {
        if (this._new_role_in_process) return;
        this.new_role_name = '';
        this._new_role_in_error = false;
        this.isAddNewRole = true;
    }

    hideAddNewRole() {
        if (this._new_role_in_process) return;
        this.isAddNewRole = false;
    }

    addNewRole(name: any) {
        if (this._new_role_in_process) return;
        this._new_role_in_error = false;
        this._new_role_in_process = true;
        this.usersService.addNewRole(name).subscribe(
            (res) => {
                this._setLoadedRoles(res);
                this.toasterService.pop('success', 'Success', 'Role Added');
                this._new_role_in_process = false;
                this.isAddNewRole = false;
            },
            (error) => {
                try {
                    this.toasterService.pop('error', 'Error', 'Error adding new role');
                    this._new_role_in_process = false;
                    this._new_role_in_error = true;
                    this._new_role_txt_error = false;

                    for (let err of error.json().errors) {
                        if (err.field == 'name') {
                            this._new_role_txt_error = err.message;
                            break;
                        }
                    }
                } catch (e) {}
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/views/role/role-editor/role-editor.component.ts